import InPageNotification from './InPageNotification';

export default InPageNotification;
